import Config from './config'
import AppEvents from './appevents'
import { Enum } from '@/helpers/enum'
import { Account } from '@/models/account'
import { Category } from '@/models/category'
import { CurrencyConversationManager } from '@/models/currency'

export const DataStateKind = {
  notInitiated: Symbol(0),
  loading: Symbol(1),
  loaded: Symbol(2),
  error: Symbol(3),
  cancelled: Symbol(4)
}


export class DataState {
  constructor (state) {
    this.state = state
    this.ref = null
    this.msg = null
  }

  isLoading () {
    return this.state === DataStateKind.loading
  }

  isLoaded () {
    return this.state === DataStateKind.loaded
  }

  isLoadedOrNotInit () {
    return this.isLoaded() || (this.state === DataStateKind.notInitiated)
  }

  isNotInit () {
    return (this.state === DataStateKind.notInitiated)
  }

  isError () {
    return this.state === DataStateKind.error
  }

  changeToLoading () {
    this.state = DataStateKind.loading
  }

  changeToLoaded () {
    this.state = DataStateKind.loaded
  }

  changeToError (msg) {
    this.state = DataStateKind.error
    this.msg = msg
  }

  static newLoading () {
    return new DataState(DataStateKind.loading)
  }

  static newNotInit () {
    return new DataState(DataStateKind.notInitiated)
  }
}

export const AppState = {
  // Based on https://vuejs.org/v2/guide/state-management.html#Simple-State-Management-from-Scratch

  instance: {
    user: {},
    logoutUrl: Config.LogoutPath,
    initDataReady: false,
    userLoggedIn: false,
    pageTitle: '',
    activePage: 'home',
    breadcrumb: [],
    appClass: '',
    roundedFigure: false,
    currencyConv: CurrencyConversationManager.fromCache(),

    numberGoodBadClass (x, y) {
      return {
        'nothing': y === undefined || y === null,
        'zero': y === 0,
        'natural': x === y,
        'good': x < y,
        'bad': x > y
      }
    }
  },
  prepareInitData (next) {
    if (this.instance.initDataReady) {
      next()
    } else {
      Account.list().then(() => {
        return Category.list()
      }).then(() => {
        next()
      }).catch(() => {
        next()
      })
    }
  },
  updateUserLoggedIn (status) {
    this.instance.userLoggedIn = status
  },
  updateTitles (docTitle, pageTitle) {
    if (docTitle === Config.title) {
      document.title = docTitle
    } else {
      document.title = `${docTitle} | ${Config.title}`
    }
    if (pageTitle) {
      this.instance.pageTitle = pageTitle
    } else {
      this.instance.pageTitle = docTitle
    }
  },
  updateActivePage (pageKey) {
    this.instance.activePage = pageKey
  },
  updateRoundedFigure (rounded) {
    this.instance.roundedFigure = rounded
  },
  updateBreadcrumb (items) {
    this.instance.breadcrumb = items
  },
  resetBreadcrumb () {
    this.instance.breadcrumb = []
  },
  updateAppClass (newClass) {
    this.instance.appClass = newClass
  }
}
